
import { Brand, Category, NavItem } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Trayectoria', href: '#nosotros' },
  { label: 'Capacidades', href: '#capacidades' },
  { label: 'Contacto', href: '#contacto' },
];

/** 
 * REEMPLAZAR AQUÍ: Logos de las marcas que distribuyen 
 */
export const BRANDS: Brand[] = [
  { name: 'Brand 1', logo: '/brands/1.png' },
  { name: 'Brand 2', logo: '/brands/2.png' },
  { name: 'Brand 3', logo: '/brands/3.png' },
  { name: 'Brand 4', logo: '/brands/4.png' },
  { name: 'Brand 5', logo: '/brands/5.png' },
  { name: 'Brand 6', logo: '/brands/6.png' },
  { name: 'Brand 7', logo: '/brands/7.png' },
  { name: 'Brand 8', logo: '/brands/8.png' },
  { name: 'Brand 9', logo: '/brands/9.png' },
  { name: 'Brand 10', logo: '/brands/10.png' },
];

/** 
 * REEMPLAZAR AQUÍ: Imágenes de las Unidades de Negocio (campo 'image') 
 */
export const BUSINESS_UNITS = [
  {
    id: 'mass-consumption',
    title: 'División Consumo Masivo',
    subtitle: 'Alimentos y Bebidas',
    description: 'Gestión integral de productos de alta rotación para la red de supermercados, autoservicios y almacenes. Líderes en volumen y capilaridad de entrega.',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&q=80&w=1000',
    tags: ['Primeras Marcas', 'Stock Permanente', 'Precios Competitivos']
  },
  {
    id: 'personal-care',
    title: 'División Cuidado y Salud',
    subtitle: 'Higiene y Bienestar',
    description: 'Representación estratégica de líneas líderes en perfumería, cosmética y salud sexual (Alianza Prime). Distribución especializada con trazabilidad garantizada.',
    icon: 'ShieldCheck',
    image: '/cuidado-salud.jpg',
    tags: ['Distribución Oficial', 'Garantía Prime', 'Logística Especializada']
  },
  {
    id: 'logistics',
    title: 'Excelencia Logística',
    subtitle: 'Infraestructura y Distribución',
    description: 'Contamos con una flota propia y centros de almacenamiento optimizados para asegurar que cada producto llegue en condiciones óptimas a su destino.',
    icon: 'Smartphone',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=1000',
    tags: ['Flota Propia', 'Tecnología de Tracking', 'Entrega 24/48hs']
  }
];
